import { faPhotoFilm } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import { notify } from '../../../components/Notify';

export default function ButtonPng({
  nome,
  textButton,
  cpf,
  id = 'node_to_png20252026',
  disabled = false
}) {
  const [isHover, setIsHover] = useState(false);

  const downloadDivAsPdf = async () => {
    const container = document.getElementById(id);
    if (!container) return notify('Elemento não encontrado.', 'error');

    const img = container.querySelector('img');
    if (!img || !img.src) return notify('Imagem não encontrada.', 'error');

    const originalWidth = 350;
    const originalHeight = 658;
    const scale = 2;
    const width = originalWidth * scale;
    const height = originalHeight * scale;

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [width, height],
    });

    pdf.addImage(img.src, 'PNG', 0, 0, width, height);

    const linkX = 122 * scale;
    const linkY = height - 195;
    const linkWidth = 107 * scale;
    const linkHeight = 35 * scale;

    pdf.link(linkX, linkY, linkWidth, linkHeight, {
      url: `https://uenestudante.vercel.app/validar/${cpf}`,
    });

    pdf.save(`${nome}.pdf`);
  };

  // Estilos customizados
  const buttonStyle = {
    backgroundColor: disabled ? '#ccc' : (isHover ? '#125a63' : '#166f7a'),
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'background 0.3s ease',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    fontFamily: 'sans-serif'
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
      <button
        onClick={downloadDivAsPdf}
        disabled={disabled}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={buttonStyle}
      >
        <FontAwesomeIcon icon={faPhotoFilm} />
        {textButton}
      </button>
    </div>
  );
}